/**
 * transforms string to have the first char uppercase, and the rest lowercase
 * @param val: string to transform
 */
export const capitalizeFirstLetter = (val: string): string => {
  return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
};
